import { ModalPopup, ConfirmationModalContent } from 'components';
import { FC } from 'react';
import { FormikProps } from 'formik';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  formik: {
    dirty: FormikProps<any>['dirty'];
    isValid: FormikProps<any>['isValid'];
    handleSubmit: FormikProps<any>['handleSubmit'];
    validateForm: FormikProps<any>['validateForm'];
    setTouched: FormikProps<any>['setTouched'];
  };
  onDiscard: () => void;
};

const UnsavedChangesModal: FC<Props> = ({ open, setOpen, formik, onDiscard }) => {
  const onClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    setOpen(false);
    if (formik.isValid && formik.dirty) {
      formik.handleSubmit();
      onDiscard();
    }
    if (!formik.isValid && formik.dirty) {
      formik.validateForm().then((errors) => {
        const errorKeys = Object.keys(errors);
        if (errorKeys.length > 0) {
          const touched = errorKeys.reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {} as Record<string, boolean>);
          formik.setTouched(touched);
        }
      });
    }
  };
  const handleDiscard = () => {
    setOpen(false);
    onDiscard();
  };
  return (
    <ModalPopup open={open} handleClose={onClose}>
      <ConfirmationModalContent
        confirmButtonText="Save changes"
        rejectButtonText="Discard changes"
        title="You have unsaved changes"
        handleConfirm={handleSave}
        handleReject={handleDiscard}
      />
    </ModalPopup>
  );
};

export default UnsavedChangesModal;
